// extracted by mini-css-extract-plugin
export default {"perception":"Perception_perception__ckM21","title-pic":"Perception_title-pic__zmaPk"};